<template>
  <div id="app">
    <Nav />
    <div class="uk-container">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <foot-nav/>
  </div>
</template>

<script>
import Nav from "./components/Nav"
import FootNav from "./components/Footer"
export default {
  title: 'CUSEREMP',
  name: "App",
  components: { 
    Nav, 
    FootNav
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}

/*h1 {
  
  font-size: 60px;
}*/

#category {
  /* font-family: Staatliches; */
  font-weight: 500;
}

#title {
  letter-spacing: 0.4px;
  font-size: 22px;
  font-size: 1.375rem;
  line-height: 1.13636;
}

#banner {
  margin: 20px;
  height: 800px;
}

#editor {
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.75;
}

.uk-navbar-container {
  background: #fff !important;
  /* font-family: Staatliches; */
}

img:hover {
  opacity: 1;
  transition: opacity 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
}

.color-primary{
  background-color: #003780ff !important;
}

.color-secondary{
  background-color: #ff834fff !important;
}

.mt-15{
  margin-top:15px;
}

.uk-navbar-nav>li>a:hover{
  color: #fff;
}

.uk-card-media-top>img{
  border-radius:10px;
}

</style>